(function (angular) {
	'use strict';

	angular.module('investorReferralsModule', [
		'coreModule',
		'ngclipboard'
	]);
})(window.angular);